import { createContext } from 'react';
import { CmsSiteConfig } from '@/services/cms/models/CmsSiteConfig';

export type SiteContextValue = {
    site?: CmsSiteConfig;
};
export const SiteProviderContext = createContext<SiteContextValue>({});
